import React, { PureComponent } from "react";
import Fragment from 'react-dot-fragment';
import styled from 'styled-components';
import { Link } from "react-router";

import { getRequest } from '../../../../../api/ApiService';

import OneVisualLayout from "../../layouts/one-visual";

const FeedbackBlock = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d5d9dd;
  padding: 20px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-bottom: 20px;
`;

const FeedbackBlockTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 7px;
`;

const FeedbackBlockList = styled.ul`
  line-height: 24px;
`;

const FeedbackBlockListItem = styled.li`
  line-height: 24px;
`;

const FeedbackBlockBold = styled.span`
  font-weight: 700;
`;

class WhyTargetsWerentHit extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      staticConstants: {}
    };
  }

  componentDidMount() {
    getRequest(`${process.env.REACT_APP_API_URL}static/constants/`)
      .then(res => {
        const staticConstants = res.body[0] || {};
        console.log('staticConstants', staticConstants);

        this.setState({
          staticConstants
        });
      })
      .catch(err => { });
  }

  render() {
    const { performanceFeedbacksGame, gamesTargets, activeRound } = this.props;
    const { staticConstants } = this.state;
    console.log('performanceFeedbacksGame', performanceFeedbacksGame);

    const hasDidNotSubmitOrInsufficientCapital = performanceFeedbacksGame.some(item =>
      item.type === "Did not submit" || item.type === "Insufficient capital"
    );

    const submissionStatusContent = hasDidNotSubmitOrInsufficientCapital ? <p>Some teams didn’t post all of their decisions either because they weren’t made or didn’t have sufficient capital to post them (<Link to={`/instructor/performance-feedback/decisions-not-submitted?round=${activeRound}`}>learn more</Link>).</p>
      : <p>All teams posted their decisions successfully for this round.</p>;

    const hasProductMarketFit = performanceFeedbacksGame.some(item => item.type === "Product market fit");
    const hasPriceRangeFailed = performanceFeedbacksGame.some(item => item.type === "Price range failed");
    const hasMarketFitIssues = hasProductMarketFit || hasPriceRangeFailed;

    const hasLowExpectedRevenue = performanceFeedbacksGame.some(item => item.type === "Expected revenue low");

    const hasAwareness = performanceFeedbacksGame.some(item => item.type === "Awareness");

    const hasMarketShareNetRevenuesTargets = gamesTargets[0].net_revenues !== 0 || gamesTargets[0].market_share !== 0;
    const hasMarketShareOrRevenueFail = performanceFeedbacksGame.some(item =>
      item.type === "Market share" || item.type === "Revenue fail"
    );
    const hasNoRevenueIssues = !performanceFeedbacksGame.some(item =>
      item.type === "Product market fit" ||
      item.type === "Price range failed" ||
      item.type === "Expected revenue low" ||
      item.type === "Awareness"
    );

    const hasNegativeGrossMargins = performanceFeedbacksGame.some(item => item.type === "Negative gross margins");

    const hasGrossMarginFail = performanceFeedbacksGame.some(item => item.type === "Gross margin fail");

    const hasAutoOrMobileOverproduced = performanceFeedbacksGame.some(item =>
      item.type === "Auto overproduced" || item.type === "Mobile overproduced"
    );

    const hasHighInterest = performanceFeedbacksGame.some(item => item.type === "High interest");

    const hasRoeRoaEps = gamesTargets[0].roe !== 0 || gamesTargets[0].roa !== 0 || gamesTargets[0].earnings_per_share !== 0;

    const hasRoeRoaEpsFail = performanceFeedbacksGame.some(item =>
      item.type === "Roe fail" || item.type === "Roa fail" || item.type === "EPS fail"
    );

    const hasNoGrossMarginIssuesOrOverproducedOrHighInterest = !performanceFeedbacksGame.some(item =>
      item.type === "Negative gross margins" ||
      item.type === "Gross margin fail" ||
      item.type === "Auto overproduced" ||
      item.type === "Mobile overproduced" ||
      item.type === "High interest"
    );

    return (
      <OneVisualLayout
        section="Feedback | OVERALL"
        title="Overall Feedback"
        paragraph1={(
          <Fragment>
            <FeedbackBlock>
              <FeedbackBlockTitle>Submission Status</FeedbackBlockTitle>
              <p>{submissionStatusContent}</p>
            </FeedbackBlock>
            <FeedbackBlock>
              <FeedbackBlockTitle>Feedback: Generating Market Share & Revenues</FeedbackBlockTitle>
              <FeedbackBlockList>
                {hasMarketFitIssues && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Market Fit Challenges:</FeedbackBlockBold> Some teams have a product that is either aimed at customers with low demand {hasProductMarketFit && <Fragment>(<Link to={`/instructor/performance-feedback/market-share/product-met-interest?round=${activeRound}`}>learn more</Link>)</Fragment>} or is priced outside what the target market is willing to pay {hasPriceRangeFailed && <Fragment>(<Link to={`/instructor/performance-feedback/market-share/outside-price-range?round=${activeRound}`}>learn more</Link>)</Fragment>}. They need to review/re-visit the Customer Analysis.
                  </FeedbackBlockListItem>
                )}

                {hasLowExpectedRevenue && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Price & Supply Misalignment:</FeedbackBlockBold> Some teams priced or produced too low relative to customer demand and what these customers are willing to pay. This is likely due to poor coordination between operations function (production) and marketing function, which set’s product pricing in the sim. <a href={`/instructor/performance-feedback/revenues/products-selling-price?round=${activeRound}`}>Learn more</a>.
                  </FeedbackBlockListItem>
                )}

                {hasAwareness && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Awareness:</FeedbackBlockBold> Some teams are underinvesting in awareness, possibly overlooking guidance in the business case. Review the Awareness page in Team Reports to compare against competitors. if low, consider increasing promotional spend. <a href={`/instructor/performance-feedback/market-share/product-promotion?round=${activeRound}`}>Learn more</a>.
                  </FeedbackBlockListItem>
                )}

                {hasMarketShareNetRevenuesTargets && hasMarketShareOrRevenueFail && hasNoRevenueIssues && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Market Mix Challenges:</FeedbackBlockBold> Some teams marketing mix may be hindering their performance. They should review the Marketing Analysis within their Team Report to compare their product’s features, pricing, and awareness with the top teams in their competition.
                  </FeedbackBlockListItem>
                )}
              </FeedbackBlockList>
            </FeedbackBlock>
            <FeedbackBlock>
              <FeedbackBlockTitle>Feedback on Generating Profits</FeedbackBlockTitle>
              <FeedbackBlockList>
                {hasNegativeGrossMargins && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Negative Margins:</FeedbackBlockBold> Some teams have set their product’s selling price below its production cost—perhaps assuming this is a nonprofit game or making decisions in silos. Their Marketing team (which sets the price) and Operations team (which manages cost) should coordinate more closely (<Link to={`/instructor/performance-feedback/gross-margins/running-non-profit?round=${activeRound}`}>learn more</Link>).
                  </FeedbackBlockListItem>
                )}

                {hasGrossMarginFail && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Low Gross Margins:</FeedbackBlockBold> Some teams’ margins are falling short of their gross margin targets. These teams should take a closer look at how their product’s selling price and manufacturing costs affect overall profitability (<Link to={`/instructor/performance-feedback/gross-margins/selling-price-too-low?round=${activeRound}`}>learn more</Link>).
                  </FeedbackBlockListItem>
                )}

                {hasAutoOrMobileOverproduced && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Overproduced:</FeedbackBlockBold> Some teams have overproduced, resulting in unsold inventory that incurs a holding cost of approximately {staticConstants.holding_rate && staticConstants.holding_rate.toLocaleString('en-US', { style: 'percent' })}. <FeedbackBlockBold>Note:</FeedbackBlockBold> a leading product within a segment (e.g., mobile) typically captures around 15% of that market. Producing beyond this level may lead to excess inventory.
                  </FeedbackBlockListItem>
                )}

                {hasHighInterest && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>High interest:</FeedbackBlockBold> Some teams have outstanding loans with interest charges exceeding 25% of their total revenues. These teams may struggle to achieve profitability and should consider repaying a portion of their loans.
                  </FeedbackBlockListItem>
                )}

                {hasRoeRoaEps && hasRoeRoaEpsFail && hasNoGrossMarginIssuesOrOverproducedOrHighInterest && (
                  <FeedbackBlockListItem>
                    <FeedbackBlockBold>Profit Challenges:</FeedbackBlockBold> Some teams are not generating enough revenue to cover expenses. This may be because their marketing mix doesn’t align with customer preferences and demand or is not as appealing as competitors.
                  </FeedbackBlockListItem>
                )}
              </FeedbackBlockList>
            </FeedbackBlock>
          </Fragment>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }
}

export default WhyTargetsWerentHit;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/index.js